import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { authActions } from '../store/auth/actions';

const Logout = () => {
  const { t } = useTranslation(['translations']);

  const dispatch = useDispatch();

  dispatch(authActions.logout());

  return <h1>{t('logout_page.title')}..</h1>;
};

export default Logout;
